<template>
  <div class="v-login-agreement">
    <i class="v-login-agreement__icon"
      :class="{ 'checked': isCheck }"
      @click="toggleAgreement"
    ></i>
    已阅读并同意<a :href="`${graph}/articles/agreement`" target="_blank">《三维家用户服务协议》</a>
    和<a :href="`${graph}/articles/privacy`" target="_blank">《三维家隐私政策》</a>
  </div>
</template>

<script>
export default {
  name: 'agreement',
  props: {
    graph: { type: String, default: '' },
  },
  data() {
    return {
      isCheck: 1,
    };
  },
  methods: {
    toggleAgreement() {
      this.isCheck = this.isCheck === 0 ? 1 : 0;
      this.$emit('toggleAgreement', this.isCheck);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../libs/mixin.scss';

.v-login-agreement {
  position: relative;
  font-size: 12px;
  color: #999;
  padding-left: 24px;
  line-height: 17px;
  a {
    color: $mainColor;
    cursor: pointer;
    text-decoration: none;
    outline: none;
  }
  .v-login-agreement__icon {
    position: absolute;
    left: 0;
    top: 1px;
    background: url('../imgs/checkbox.png') center no-repeat;
    background-size: 16px auto;
    display: inline-block;
    width: 16px;
    height: 16px;
    cursor: pointer;
    vertical-align: middle;
    &.checked {
      color: $mainColor;
      background-image: url('../imgs/checkbox-on.png');
    }
  }
}
</style>
